// import React from "react";
// import {
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Button,
//   FormGroup,
//   Label,
//   Input,
//   FormFeedback,
// } from "reactstrap";
// import { Formik, Form, Field, ErrorMessage } from "formik";
// import * as Yup from "yup";

// const validationSchema = Yup.object().shape({
//   name: Yup.string().required("Session name is required"),
//   startDate: Yup.date()
//     .required("Start date is required")
//     .typeError("Invalid date format"),
//   endDate: Yup.date()
//     .required("End date is required")
//     .typeError("Invalid date format")
//     .min(Yup.ref("startDate"), "End date cannot be before start date"),
// });

// const AddSessionModal = ({ isOpen, toggle, onSubmit }) => {
//   const initialValues = {
//     name: "",
//     startDate: "",
//     endDate: "",
//   };

//   const handleSubmit = (values, { resetForm }) => {
//     // Convert date format from YYYY-MM-DD → DD-MM-YYYY
//     const formattedValues = {
//       name: values.name,
//       startDate: formatDate(values.startDate),
//       endDate: formatDate(values.endDate),
//     };

//     if (onSubmit) onSubmit(formattedValues);
//     resetForm();
//     toggle();
//   };

//   // Format date from yyyy-mm-dd → dd-mm-yyyy
//   const formatDate = (dateStr) => {
//     if (!dateStr) return "";
//     const [year, month, day] = dateStr.split("-");
//     return `${day}-${month}-${year}`;
//   };

//   return (
//     <Modal isOpen={isOpen} toggle={toggle} centered>
//       <ModalHeader toggle={toggle}>Add Session</ModalHeader>
//       <Formik
//         initialValues={initialValues}
//         validationSchema={validationSchema}
//         onSubmit={handleSubmit}
//       >
//         {({ touched, errors }) => (
//           <Form>
//             <ModalBody>
//               <FormGroup>
//                 <Label for="name">
//                   Session Name <span className="text-danger">*</span>
//                 </Label>
//                 <Field
//                   name="name"
//                   as={Input}
//                   invalid={touched.name && !!errors.name}
//                   placeholder="Enter session name (e.g., 2024-2025)"
//                 />
//                 <ErrorMessage
//                   name="name"
//                   component={FormFeedback}
//                   className="d-block"
//                 />
//               </FormGroup>

//               <FormGroup>
//                 <Label for="startDate">
//                   Start Date <span className="text-danger">*</span>
//                 </Label>
//                 <Field
//                   type="date"
//                   name="startDate"
//                   as={Input}
//                   invalid={touched.startDate && !!errors.startDate}
//                 />
//                 <ErrorMessage
//                   name="startDate"
//                   component={FormFeedback}
//                   className="d-block"
//                 />
//               </FormGroup>

//               <FormGroup>
//                 <Label for="endDate">
//                   End Date <span className="text-danger">*</span>
//                 </Label>
//                 <Field
//                   type="date"
//                   name="endDate"
//                   as={Input}
//                   invalid={touched.endDate && !!errors.endDate}
//                 />
//                 <ErrorMessage
//                   name="endDate"
//                   component={FormFeedback}
//                   className="d-block"
//                 />
//               </FormGroup>
//             </ModalBody>

//             <ModalFooter>
//               <Button color="light" onClick={toggle}>
//                 Cancel
//               </Button>
//               <Button color="primary" type="submit">
//                 <i className="ri-save-3-line align-bottom me-1"></i> Save
//               </Button>
//             </ModalFooter>
//           </Form>
//         )}
//       </Formik>
//     </Modal>
//   );
// };

// export default AddSessionModal;

import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

const AddSessionModal = ({ isOpen, toggle, onSubmit }) => {
  const initialValues = {
    name: "",
    startDate: "",
    endDate: "",
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Session name is required"),
    startDate: Yup.date().required("Start date is required"),
    endDate: Yup.date()
      .required("End date is required")
      .min(Yup.ref("startDate"), "End date cannot be before start date"),
  });

  const handleSubmit = (values) => {
    // Format date to dd-mm-yyyy before sending
    const formatDate = (date) => {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    };

    const payload = {
      name: values.name,
      startDate: formatDate(values.startDate),
      endDate: formatDate(values.endDate),
    };

    if (onSubmit) onSubmit(payload);
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Add Session</ModalHeader>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, setFieldValue, touched, errors }) => (
          <Form>
            <ModalBody>
              <FormGroup>
                <Label for="name">
                  Session Name <span className="text-danger">*</span>
                </Label>
                <Field
                  name="name"
                  as={Input}
                  invalid={touched.name && !!errors.name}
                  placeholder="Enter session name (e.g., 2024-2025)"
                />
                <ErrorMessage
                  name="name"
                  component={FormFeedback}
                  className="d-block"
                />
              </FormGroup>

              <FormGroup>
                <Label for="startDate">
                  Start Date <span className="text-danger">*</span>
                </Label>
                <Flatpickr
                  className={`form-control ${
                    touched.startDate && errors.startDate ? "is-invalid" : ""
                  }`}
                  options={{
                    dateFormat: "d/m/Y",
                  }}
                  value={values.startDate}
                  onChange={(date) => setFieldValue("startDate", date[0])}
                />
                <ErrorMessage
                  name="startDate"
                  component="div"
                  className="invalid-feedback d-block"
                />
              </FormGroup>

              <FormGroup>
                <Label for="endDate">
                  End Date <span className="text-danger">*</span>
                </Label>
                <Flatpickr
                  className={`form-control ${
                    touched.endDate && errors.endDate ? "is-invalid" : ""
                  }`}
                  options={{
                    dateFormat: "d/m/Y",
                  }}
                  value={values.endDate}
                  onChange={(date) => setFieldValue("endDate", date[0])}
                />
                <ErrorMessage
                  name="endDate"
                  component="div"
                  className="invalid-feedback d-block"
                />
              </FormGroup>
            </ModalBody>

            <ModalFooter>
              <Button className="btn-sm" color="secondary" onClick={toggle}>
                Cancel
              </Button>
              <Button color="success" className="btn-sm" type="submit">
                Add Session
              </Button>
            </ModalFooter>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default AddSessionModal;
